import React from "react";

class CustomToggle extends React.Component {
  constructor(props) {
    super(props);
    this.handleClick = this.handleClick.bind(this);
  }

  handleClick(e) {
    e.preventDefault();
    this.props.onClick(e);
  }

  render() {
    return (
      <span style={{ cursor: "pointer" }} onClick={this.handleClick}>
        {this.props.children}
      </span>
    );
  }
}

class CustomMenu extends React.Component {
  render() {
    const { children } = this.props;

    return (
      <div className="dropdown-menu">
        <ul className="list-unstyled">{React.Children.toArray(children)}</ul>
      </div>
    );
  }
}

export { CustomMenu, CustomToggle };
